import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  { path: '', component: HomeComponent },

  // Auth
  { path: 'login', loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent) },
  { path: 'register', loadComponent: () => import('./features/auth/register/register.component').then(m => m.RegisterComponent) },

  // Patient
  { path: 'patient/dashboard', loadComponent: () => import('./features/patient/patient-dashboard/patient-dashboard.component').then(m => m.PatientDashboardComponent), canActivate: [authGuard] },

  // Patient — Catalogue & Panier
  { path: 'catalog', loadComponent: () => import('./features/catalog/catalog-list/catalog-list.component').then(m => m.CatalogListComponent) },
  { path: 'cart', loadComponent: () => import('./features/catalog/cart/cart.component').then(m => m.CartComponent) },
  { path: 'checkout', loadComponent: () => import('./features/catalog/checkout/checkout.component').then(m => m.CheckoutComponent), canActivate: [authGuard] },

  // Patient — Ordonnance
  { path: 'prescription/upload', loadComponent: () => import('./features/prescription/upload-prescription/upload-prescription.component').then(m => m.UploadPrescriptionComponent), canActivate: [authGuard] },
  { path: 'prescription/status', loadComponent: () => import('./features/prescription/prescription-status/prescription-status.component').then(m => m.PrescriptionStatusComponent), canActivate: [authGuard] },

  // Patient — Suivi & Historique commandes
  { path: 'orders/track/:id', loadComponent: () => import('./features/orders/order-tracking/order-tracking.component').then(m => m.OrderTrackingComponent), canActivate: [authGuard] },
  { path: 'orders/track', loadComponent: () => import('./features/orders/order-tracking/order-tracking.component').then(m => m.OrderTrackingComponent), canActivate: [authGuard] },

  // Patient — Profil
  { path: 'profile', loadComponent: () => import('./features/profile/user-profile/user-profile.component').then(m => m.UserProfileComponent), canActivate: [authGuard] },
  { path: 'profile/history', loadComponent: () => import('./features/profile/medical-history/medical-history.component').then(m => m.MedicalHistoryComponent), canActivate: [authGuard] },

  // Chat
  { path: 'chat', loadComponent: () => import('./features/chat/medical-chat/medical-chat.component').then(m => m.MedicalChatComponent), canActivate: [authGuard] },

  // Livreur
  { path: 'livreur/dashboard', loadComponent: () => import('./features/livreur/livreur-dashboard/livreur-dashboard.component').then(m => m.LivreurDashboardComponent), canActivate: [authGuard] },
  { path: 'livreur/upload-documents', loadComponent: () => import('./features/auth/upload-documents/upload-documents.component').then(m => m.UploadDocumentsComponent), canActivate: [authGuard] },

  // Pharmacie partenaire
  { path: 'pharmacie/dashboard', loadComponent: () => import('./features/pharmacie/pharmacie-dashboard/pharmacie-dashboard.component').then(m => m.PharmacieDashboardComponent), canActivate: [authGuard] },

  // Admin back-office
  { path: 'admin', loadComponent: () => import('./features/admin/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent), canActivate: [authGuard] },

  { path: '**', redirectTo: '' }
];
